import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { withViewService } from 'components/common/permissions';
import { isPalGuestPaymentGroup } from 'util/rbac';
import { useAuth } from 'hooks';
import DefaultDetail from './DefaultDetail';
import PayerDetail from './PayerDetail';
import Payers from './Payers';
import {
  BASE_PATH,
  DETAIL_PATH,
  SEARCH_PATH,
  PAL_GUEST_PATH,
  PAL_GUEST_PAYMENT_PATH,
} from './paths';
import GuestPayerDetail from './PayerDetail/GuestPayerDetail';
import PalGuestPayment from './PalGuestPayment';
import { selectedFspIdSelector } from '../../../selectors/fsp';
import usePalGuestPaymentEnabled from '../../../hooks/usePalGuestPaymentEnabled';
import { load as loadFspConfigPayALoan } from '../../../model/fspConfigPayALoan';

const Service = () => {
  const dispatch = useDispatch();
  const selectedFspId = useSelector(selectedFspIdSelector);
  const isPalGuestPaymentEnabled = usePalGuestPaymentEnabled();
  const isInPayerDetail = Boolean(
    useRouteMatch(`${DETAIL_PATH}/:fspId/:payerId`)
  );
  const auth = useAuth();
  const hasPalGuestPaymentGroup =
    auth?.groups?.some((g) => isPalGuestPaymentGroup(g.name)) ?? false;

  useEffect(() => {
    if (isPalGuestPaymentEnabled && selectedFspId && !isInPayerDetail) {
      dispatch(loadFspConfigPayALoan(selectedFspId));
    }
  }, [dispatch, isPalGuestPaymentEnabled, isInPayerDetail, selectedFspId]);

  return (
    <Switch>
      <Route component={Payers} path={SEARCH_PATH} />
      <Route component={PayerDetail} path={`${DETAIL_PATH}/:fspId/:payerId`} />
      <Route component={GuestPayerDetail} path={`${PAL_GUEST_PATH}/:number`} />
      {isPalGuestPaymentEnabled && hasPalGuestPaymentGroup && (
        <Route component={PalGuestPayment} path={PAL_GUEST_PAYMENT_PATH} />
      )}
      <Route component={DefaultDetail} path={DETAIL_PATH} />
      <Redirect from={BASE_PATH} to={SEARCH_PATH} />
    </Switch>
  );
};

export default withViewService(Service);
